<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>未精算整理詳細画面</h1>
<app-sgke010d-search-result [isDetail]="true" *ngIf="searchResultList?.length > 0"
    [responseList]="searchResultList"></app-sgke010d-search-result>

<app-sgke020d-business-type (changedClsfyEvent)="onChange($event)" (onClickRcvmnyInfoEvent)="onClickRcvmnyInfo()"
    (clickRpaytoCfrmPostCardEvent)="clickRpaytoCfrmPostCard()" (onClickApprevReqEvent)="apprevReqReset()"
    (onClickReturnPage)="returnPage()" [registType]="registType"
    [kakuhoNotarrive]="searchResultList[0]?.kakuhoNotarrive"
    [kinkoStatuscode]="searchResultList[0]?.kinkoStatuscode"></app-sgke020d-business-type>
<div class="keshikomi" *ngIf="registType=='1'">
    <app-sgke030d-view [kinkoMno]="searchResultList[0]?.kinkoMno" [kinkoRrkno]="searchResultList[0]?.kinkoRrkno"
        [receiveMoneyNo]="searchResultList[0]?.receiveMoneyNo" [recptFixNo]="searchResultList[0]?.paymentContractNo"
        [remny]="searchResultList[0]?.remny" [kinkoUpdateSrno]="searchResultList[0]?.kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="searchResultList[0]?.kinkoexUpdatesequencenumber"
        (clearMessageEmit)="clearErrorMsg()" (searchEmit)="search($event)"
        (msgEmit)="showMsg($event)"></app-sgke030d-view>
</div>
<div class="furikae" *ngIf="registType=='2'">
    <app-sgke040d-view [kinkoMno]="searchResultList[0]?.kinkoMno" [kinkoRrkno]="searchResultList[0]?.kinkoRrkno"
        [kinkoUpdateSrno]="searchResultList[0]?.kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="searchResultList[0]?.kinkoexUpdatesequencenumber" (searchEmit)="search()"
        (msgEmit)="showMsg($event)" (clearMessageEmit)="clearErrorMsg()"></app-sgke040d-view>
</div>
<div class="henkin" *ngIf="registType=='3'">
    <app-sgke050d-regist [hyojiCndtFlg]="true" [kinkoMno]="searchResultList[0]?.kinkoMno"
        [kinkoRrkno]="searchResultList[0]?.kinkoRrkno" [repayMno]="searchResultList[0]?.repayMno"
        [recptFixNo]="searchResultList[0]?.paymentContractNo" [remny]="searchResultList[0]?.remny"
        [kinkoUpdateSrno]="searchResultList[0]?.kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="searchResultList[0]?.kinkoexUpdatesequencenumber" (searchEmit)="search()"
        (msgEmit)="showMsg($event)" (clearMessageEmit)="clearErrorMsg()"></app-sgke050d-regist>
</div>
<div class="henkaku" *ngIf="registType=='4'">
    <app-sgke060d-regist [kinkoMno]="searchResultList[0]?.kinkoMno" [kinkoRrkno]="searchResultList[0]?.kinkoRrkno"
        [repayMno]="searchResultList[0]?.repayMno" [recptFixNo]="searchResultList[0]?.paymentContractNo"
        [kinkoUpdateSrno]="searchResultList[0]?.kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="searchResultList[0]?.kinkoexUpdatesequencenumber" (searchEmit)="search($event)"
        (msgEmit)="showMsg($event)" (clearMessageEmit)="clearErrorMsg()"></app-sgke060d-regist>
</div>
<div class="juto" *ngIf="registType=='5'">
    <app-sgke070d-regist [kinkoMno]="searchResultList[0]?.kinkoMno" [kinkoRrkno]="searchResultList[0]?.kinkoRrkno"
        [kinkoUpdateSrno]="searchResultList[0]?.kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="searchResultList[0]?.kinkoexUpdatesequencenumber"
        [kinkoStatuscode]="searchResultList[0]?.kinkoStatuscode" (searchEmit)="search()" (msgEmit)="showMsg($event)"
        (clearMessageEmit)="clearErrorMsg()"></app-sgke070d-regist>
</div>